import { render } from "./MarkdownField.vue?vue&type=template&id=3ce697f7"
import script from "./MarkdownField.vue?vue&type=script&lang=js"
export * from "./MarkdownField.vue?vue&type=script&lang=js"

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MarkdownField.vue"]])

export default __exports__